export default __webpack_public_path__ + "static/Tangle-5223487bed6617ef7b48cdb7ced09308.png";